import { render, staticRenderFns } from "./Triage.vue?vue&type=template&id=97c8eb0e&scoped=true"
import script from "./Triage.vue?vue&type=script&lang=js"
export * from "./Triage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c8eb0e",
  null
  
)

export default component.exports